"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateColorThemes = void 0;
var utils_1 = require("../utils");
var generateFile_1 = require("./generateFile");
// TODO: https://github.com/salute-developers/plasma/issues/512
/**
 * Генерация цветовых схем для создания глобального стиля.
 * @param {Record<string, TokenDataGroup<string>>>} colorThemes Цветовые схемы, разложенные по названиям
 * @return {GeneratedFiles}
 */
var generateColorThemes = function (colorThemes, mixin, withDeprecated, fallbackColorThemes) {
    if (mixin === void 0) { mixin = {}; }
    if (withDeprecated === void 0) { withDeprecated = false; }
    var files = [];
    var indexContent = '';
    var withKebabCase = true;
    for (var _i = 0, _a = Object.entries(colorThemes); _i < _a.length; _i++) {
        var _b = _a[_i], fileName = _b[0], themeItem = _b[1];
        var themeData = (0, utils_1.extractTokenData)(themeItem);
        var fallbackThemeData = fallbackColorThemes ? (0, utils_1.extractTokenData)(fallbackColorThemes[fileName]) : {};
        var _c = withDeprecated ? (0, utils_1.getDeprecatedVars)(fileName) : ['', ''], deprecated = _c[0], deprecatedThemeName = _c[1];
        var fileNames = [fileName];
        if (withDeprecated && deprecated) {
            fileNames.push(deprecatedThemeName);
        }
        indexContent += "export { ".concat(fileNames.join(', '), " } from './").concat(fileName, "';\n");
        files.push((0, generateFile_1.generateFile)(fileName, (0, utils_1.attachToRoot)(__assign(__assign(__assign(__assign({}, (0, utils_1.objectToCSSVariables)(themeData, 'colors', true, withKebabCase)), (0, utils_1.objectToCSSVariables)(mixin, '', true, withKebabCase)), (0, utils_1.objectToCSSVariables)(fallbackThemeData, '', false, withKebabCase)), { color: themeData.text, backgroundColor: themeData.background })), deprecated));
    }
    files.push({
        file: 'index.ts',
        content: indexContent,
    });
    return files;
};
exports.generateColorThemes = generateColorThemes;
//# sourceMappingURL=generateColorThemes.js.map